import lookup from 'rlink-data-connector/lookup';
import embedded from 'rlink-data-connector/embedded';
import Rx from 'rlink-rx';

export default function cachingRequestProvider (cachingStrategy, streamProvider) {
  return ({
    getCaches,
    request,
    requestArgs,
    ...providerArgs
  }) => {
    let shouldFetch = cachingStrategy(getCaches, request, ...requestArgs);
    if (shouldFetch) {
      return streamProvider({getCaches, request, requestArgs, ...providerArgs});
    } else {
      return Rx.Observable.just([embedded(request, requestArgs, lookup(getCaches(), request, ...requestArgs))]);
    }
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/streams/cachingRequestProvider.js